import { useState } from 'react';
import { VoiceChat } from './pages/VoiceChat';
import './App.scss';

function App() {
  const apiKey =
    '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';

  if (!apiKey) {
    return (
      <div>Error: OpenAI API key is not set in environment variables.</div>
    );
  }

  return (
    <div className="app-container">
      <div className="background-rectangles"></div>
      <VoiceChat apiKey={apiKey} />
    </div>
  );
}

export default App;
